export const EMAIL_NOTIFICATION_URL = '/email-notification';
